export default {
  label: {
    display: 'inline-block',
    margin: '0 0 5px',
    color: 'var(--gray--)'
  }
}
